import React from 'react';
import Icon from '../../../AppIcon';
import Button from '../../../ui/Button';

const ActiveScoutsList = ({ scouts, onContinueScout, onDeleteScout }) => {
  if (!scouts || scouts?.length === 0) {
    return (
      <div className="bg-card p-6 text-center">
        <Icon name="Search" size={48} className="text-muted-foreground mx-auto mb-3" />
        <h3 className="text-lg font-semibold text-foreground mb-2">No Active Scouts</h3>
        <p className="text-muted-foreground mb-4">Start your first scouting session to begin collecting startup data.</p>
        <Button variant="default" iconName="Plus" iconPosition="left">
          Start New Scout
        </Button>
      </div>
    );
  }

  return (
    <div className="bg-card">
      <div className="p-4 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground">Active Scouts</h3>
        <p className="text-sm text-muted-foreground">Continue working on your scouting sessions</p>
      </div>
      <div className="divide-y divide-border">
        {scouts?.map((scout) => (
          <div key={scout?.id} className="p-4 hover:bg-muted/50 transition-colors duration-200">
            <div className="flex items-start justify-between">
              <div className="flex-1 min-w-0">
                <div className="flex items-center space-x-2 mb-2">
                  <h4 className="text-base font-medium text-foreground truncate">
                    {scout?.companyName || 'Unnamed Company'}
                  </h4>
                  <div className={`px-2 py-1 rounded-full text-xs font-medium ${
                    scout?.status === 'draft' ? 'bg-warning/10 text-warning' :
                    scout?.status === 'in-progress'? 'bg-primary/10 text-primary' : 'bg-muted text-muted-foreground'
                  }`}>
                    {scout?.status}
                  </div>
                </div>
                
                <div className="flex items-center space-x-4 text-sm text-muted-foreground mb-2">
                  <div className="flex items-center space-x-1">
                    <Icon name="MapPin" size={14} />
                    <span>{scout?.location}</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <Icon name="Clock" size={14} />
                    <span>{scout?.lastModified}</span>
                  </div>
                </div>
                
                <div className="flex items-center space-x-4 text-sm">
                  <div className="flex items-center space-x-1">
                    <div className="w-2 h-2 bg-success rounded-full"></div>
                    <span className="text-muted-foreground">
                      {scout?.completedFields}/{scout?.totalFields} fields completed
                    </span>
                  </div>
                  <div className="flex-1 bg-muted rounded-full h-2">
                    <div 
                      className="bg-success h-2 rounded-full transition-all duration-300"
                      style={{ width: `${(scout?.completedFields / scout?.totalFields) * 100}%` }}
                    ></div>
                  </div>
                </div>
              </div>
              
              <div className="flex items-center space-x-2 ml-4">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onContinueScout(scout?.id)}
                  iconName="Play"
                  iconSize={14}
                >
                  Continue
                </Button>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onDeleteScout(scout?.id)}
                  iconName="Trash2"
                  iconSize={14}
                >
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActiveScoutsList;